import Axios from 'axios';
import { OrderCircle_CONFIG } from '@/js//config';
const RESOURCE_NAME = OrderCircle_CONFIG.API_URL + 'plans';

export default {
  getAllPlans(token) {
    var planUrl = OrderCircle_CONFIG.API_URL + '/plans-list';
    return Axios.get(`${planUrl}`);
  },

  create(data,token) {
    var planUrl = OrderCircle_CONFIG.API_URL + 'manage-plan';
    return Axios.post(`${planUrl}`, data);
  },

  updatePlan(planId,data,token) {
    var planUrl = OrderCircle_CONFIG.API_URL + '/manage-plan';
    return Axios.put(`${planUrl}/${planId}`, data);
  },
  getPlan(token) {
    return Axios.get(RESOURCE_NAME);
  },

  getPlansAndSubscription(token){
    var planAndSubscriptionUrl = OrderCircle_CONFIG.API_URL + 'plans-and-subscription';
    // return Axios.get(`${planAndSubscriptionUrl}`);
    return Axios.get(planAndSubscriptionUrl, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  }
};
